/** The editor's shape while a timeline loads: a title, two detail cards and two sections. */
export function TimelineEditorSkeleton() {
  return (
    <div className="animate-pulse" aria-busy="true" aria-label="Loading timeline">
      <div className="h-8 w-64 rounded bg-gray-200 mb-2" />
      <div className="h-4 w-40 rounded bg-gray-100 mb-6" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div className="h-28 rounded-xl bg-gray-100" />
        <div className="h-28 rounded-xl bg-gray-100" />
      </div>
      {[0, 1].map((i) => (
        <div key={i} className="mb-3 rounded-xl border border-gray-200 bg-white p-4 space-y-3">
          <div className="h-5 w-40 rounded bg-gray-200" />
          {[0, 1, 2].map((j) => (
            <div key={j} className="flex gap-3">
              <div className="h-4 w-16 rounded bg-gray-100" />
              <div className="h-4 flex-1 rounded bg-gray-100" />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
